import { AxiosError } from 'axios';

export const handleApiError = (error: unknown): never => {
  if (error instanceof AxiosError) {
    const errorMessage = error.response?.data?.message || "An error occurred with the API request.";
    console.error("API Error:", error.response?.data || error.message);
    throw new Error(errorMessage);
  } else {
    console.error("Unexpected Error:", error);
    throw new Error("An unexpected error occurred. Please try again.");
  }
};

export const validateApiResponse = (data: any, resultKey: string = 'result'): void => {
  if (!data?.[resultKey] || !Array.isArray(data[resultKey]) || data[resultKey].length === 0) {
    console.error(`❌ No data available under key "${resultKey}":`, data);
    throw new Error(`No data available under key "${resultKey}".`);
  }
};